<template>
    <div v-if="isPlatformAdmin">
        <NuxtLink v-if="environnement === 'PRODUCTION'" class="project-action" :to="`/project-admin/project/${quote?.correlationId}`" external>
            <VJoyButton variant="admin" size="xsmall">Admin project</VJoyButton>
        </NuxtLink>

        <VJoyDropdown v-else direction="down" justify="right" size="small">
            <template #dropdown-button>
                <VJoyIconButton v-if="screenSizeStore.isMobileScreen" icon="chevron-down" variant="admin" size="xsmall" />
                <VJoyButton v-else variant="admin" size="xxsmall" icon="chevron-down" icon-position="right">Admin</VJoyButton>
            </template>
            <template #dropdown-items>
                <NuxtLink class="project-action" :to="`/project-admin/project/${quote?.correlationId}`" external>Admin project</NuxtLink>
                <div class="project-action" @click="handleShowDialog('time-travel')">Time travel</div>
            </template>
        </VJoyDropdown>
    </div>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {useClientQuoteViewStore} from '@features/quote';
    import {storeToRefs} from 'pinia';
    import {useMaltEnvironnement} from '#imports';
    import {VJoyButton, VJoyDropdown, VJoyIconButton} from '@maltjoy/core-vue';
    import {useScreenSizeStore, useUserStore} from '@/common/stores';

    const userStore = useUserStore();
    const {isPlatformAdmin} = storeToRefs(userStore);
    const environnement = useMaltEnvironnement();

    const screenSizeStore = useScreenSizeStore();

    const quoteInformationStore = useClientQuoteViewStore();
    const {quote} = storeToRefs(quoteInformationStore);

    // handle purchaseOrder dialog
    const isRenewalDialogVisible = ref(false);
    const isEndingDialogVisible = ref(false);
    const isTimeTravelDialogVisible = ref(false);

    function handleShowDialog(modal: 'renew' | 'end' | 'time-travel') {
        if (modal === 'renew') {
            isRenewalDialogVisible.value = !isRenewalDialogVisible.value;
        } else if (modal === 'end') {
            isEndingDialogVisible.value = !isEndingDialogVisible.value;
        } else if (modal === 'time-travel') {
            isTimeTravelDialogVisible.value = !isTimeTravelDialogVisible.value;
        }
    }
</script>

<style lang="scss" scoped>
    :deep(.joy-dropdown-list__items) {
        padding: 0 !important;
    }

    .project-action {
        height: 48px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        column-gap: var(--joy-core-spacing-3);
        padding: 0 var(--joy-core-spacing-3);
        transition: background-color 0.3s ease;
        cursor: pointer;

        &:hover {
            background-color: var(--joy-color-secondary-10);
        }
    }
</style>
